import React from 'react';

export function useDelayedFlag(flag: boolean, delay = 300): boolean {
    const [shown, setShown] = React.useState(false);

    React.useEffect(() => {
        if (!flag) {
            setShown(false);
            return undefined;
        }
        const timer = window.setTimeout(() => setShown(true), delay);
        return () => window.clearTimeout(timer);
    }, [flag, delay]);

    return flag && shown;
}

export default useDelayedFlag;
